export const statusOptions = [
  { value: 'All', label: 'All' },
  { value: 'Draft', label: 'Draft' },
  { value: 'Published', label: 'Published' },
  { value: 'Submitted', label: 'Submitted' },
  { value: 'Cancelled', label: 'Cancelled' },
  { value: 'Without CL', label: 'Without CL' },
  { value: 'Need to be reconciled', label: 'Need to be reconciled' },
  { value: 'Need to be updated', label: 'Need to be updated' },
  { value: 'Pending Verification', label: 'Pending Verification' },
  { value: 'Verified', label: 'Verified' },
];

export const shiftOptions = ['All', 'Day', 'Night'];

export const certifiedPayrollOptions = [
  { value: 'All', label: 'All' },
  { value: 'Yes', label: 'Yes' },
  { value: 'No', label: 'No' },
];

export const forceAccountOptions = [
  { value: 'All', label: 'All' },
  { value: 'Partial', label: 'Partial' },
  { value: 'Full', label: 'Full' },
  { value: 'No', label: 'No' },
];
